<template>
  <b-modal
      v-model="localVisible"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      dialog-class="combined-export-modal"
  >
    <template #modal-header>
      <div class="d-flex">
        <BaseIcon
            icon="exclamation-triangle-fill"
            tag="i"
            class="warning-icon text-warning"
        />
        <h3>
          Combined Export Warning
        </h3>
      </div>
    </template>
    <p>
      Selecting Combined Export will include the most recent report periods for
      active and inactive BDX files based on the selected filters.
    </p>

    <p>
      <span class="font-weight-bold text-warning"> WARNING:</span> Selecting Combined Export may include multiple report periods in a
      single export file.
    </p>

    <p>
      If you would like to export a single report period, please go back and select
      <span>Export by Report Date</span>.
    </p>

    <template #modal-footer>
      <base-button type="primary" outline @click="cancel">
        Go Back
      </base-button>

      <base-button type="primary" class="ml-2" @click="confirm">
        Proceed
      </base-button>
    </template>
  </b-modal>
</template>

<script>
import { BaseIcon } from "@components/base";
export default {
  name: 'CombinedExportWarningModal',
  components: {
    BaseIcon
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.combined-export-modal .modal-body {
  padding: 0.5rem 1.4rem;
}

.combined-export-modal .modal-header {
  padding: 1rem 1rem;
}

.combined-export-modal .modal-footer {
  padding: 1rem 1rem;
}

.combined-export-modal span{
  font-weight: 600;
}

.combined-export-modal .warning-icon {
  font-size: 1.25rem;
  line-height: 1;
  width: 34px;
  height: 31px;
}
</style>
